module.exports = __webpack_public_path__ + "img/head.889cba1d.png";